const Tag = [
  'Lo-Fi',
  'Trip',
  'Cross-Rhythm',
  'Chill',
  'Drunk',
  'Japanese',
  'Electronica',
]
export default Tag